module.exports = {"id":"210872","name":"Wanderson","rating":"72","photo":"./data/images/photos/3/210872.png","club":{"name":"FK Krasnodar","logo":"./data/images/clubs/FKKrasnodar.png"},"positions":["MD","AD","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Wanderson0.json
// module id = 4316
// module chunks = 0